//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";
export default {
  name: "FloatDownload",
  data() {
    return {
      hide: false,
    };
  },
  computed: {
    ...mapState({
      linkList: (state) => state.linkList,
    }),
    hideFloat() {
      return (
        sessionStorage.getItem("hideFloatDownload") ||
        this.hide ||
        this.$route.path !== "/home"
      );
    },
  },
  methods: {
    close() {
      this.hide = true;
      sessionStorage.setItem("hideFloatDownload", true);
    },
  },
  mounted() {},
};



// WEBPACK FOOTER //
// ./src/pages/build800/components/FloatDownload.vue